import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from '@angular/core';

@Component({
    selector: 'lui-expansion-panel-header',
    template: `
    <div class="lui-expansion-panel-header-bg"></div>
    <div class="lui-expansion-panel-header-container">
      <ng-content></ng-content>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExpansionPanelHeaderComponent {
  @HostBinding('class') hostClasses = 'lui-expansion-panel-header';

  @Output() headerClicked = new EventEmitter<void>();

  @HostListener('click') onClick(): void {
    this.headerClicked.emit();
  }
}
